const DEV_PREFIX = '[DEV] ';

export function formatPageTitle(title, nodeEnv = '') {
  const normalizedTitle = String(title || '').replace(/^\[DEV\]\s*/, '');
  return String(nodeEnv || '').trim().toLowerCase() === 'production'
    ? normalizedTitle
    : `${DEV_PREFIX}${normalizedTitle}`;
}

export function installEnvironmentTitlePrefix({
  nodeEnv,
  documentObject = globalThis.document,
  MutationObserverClass = globalThis.MutationObserver,
} = {}) {
  if (!documentObject) return () => {};

  const applyPrefix = () => {
    const nextTitle = formatPageTitle(documentObject.title, nodeEnv);
    if (documentObject.title !== nextTitle) documentObject.title = nextTitle;
  };

  applyPrefix();
  if (!MutationObserverClass || !documentObject.head) return () => {};

  const observer = new MutationObserverClass(applyPrefix);
  observer.observe(documentObject.head, { childList: true, subtree: true, characterData: true });
  return () => observer.disconnect();
}
